import { Component, Input, OnInit, inject } from "@angular/core";
import { NgClass } from "@angular/common";
import { SaveButtonService } from "./eff-save-button.service";
import { TranslocoPipe } from "@jsverse/transloco";
import { EffIconComponent } from "../eff-icon/eff-icon.component";

@Component({
    selector: "eff-save-button",
    templateUrl: "./eff-save-button.component.html",
    styleUrls: ["./eff-save-button.component.scss"],
    imports: [TranslocoPipe, EffIconComponent, NgClass]
})
export class EffSaveButtonComponent implements OnInit {
    private saveButtonService = inject(SaveButtonService);

    @Input() text: string;
    @Input() saveSuccessText: string;

    saveSuccess: boolean = false;

    ngOnInit() {
        this.saveButtonService.saveSuccessEvent.subscribe(this.onSaveSuccess.bind(this));
    }

    onSaveSuccess() {
        this.saveSuccess = true;
        setTimeout(
            function () {
                this.saveSuccess = false;
            }.bind(this),
            5 * 1000
        );
    }
}
